import { GET_SAMPLE_PDF } from "../types";

const initialState = {
    pdf_samples:[]
};

export default function ( state = initialState, action ){
    switch( action.type ){
        case GET_SAMPLE_PDF:
            return {
                ...state,
                pdf_samples: action.payload
            }
            
        default :
            return state
    }
}